(() => {
  const root = document.querySelector('[data-collection-finder]')
  if (!root) return

  const makeSelect = root.querySelector('[data-finder-make]')
  const modelSelect = root.querySelector('[data-finder-model]')
  const resetBtn = root.querySelector('[data-finder-reset]')
  const statusEl = root.querySelector('[data-finder-status]')
  const emptyEl = root.querySelector('[data-finder-empty]')
  const dbEl = root.querySelector('[data-finder-db]')
  const productEls = Array.from(root.querySelectorAll('[data-finder-product]'))

  if (!makeSelect || !modelSelect || !resetBtn || !statusEl || !emptyEl || !dbEl) return

  const lang = (document.documentElement.getAttribute('lang') || 'de').toLowerCase()
  const isEN = lang.startsWith('en')

  const t = isEN
    ? {
        makeLabel: 'Select brand…',
        modelLabelFirst: 'Select brand first',
        modelLabel: 'Select model…',
        emptySelect: 'Please select a brand and model.',
        emptyModel: 'Please select a model.',
        emptyNone: 'No matching products found.',
        results: (make, model) => `Results for ${make} | ${model}`
      }
    : {
        makeLabel: 'Marke wählen…',
        modelLabelFirst: 'Erst Automarke wählen',
        modelLabel: 'Modell wählen…',
        emptySelect: 'Bitte Automarke und Modell auswählen.',
        emptyModel: 'Bitte Modell auswählen.',
        emptyNone: 'Keine passenden Produkte gefunden.',
        results: (make, model) => `Ergebnisse für ${make} | ${model}`
      }

  const normalize = (s) => String(s || '').toLowerCase().replace(/\s+/g, ' ').trim()

  const parseDb = () => {
    try {
      return JSON.parse(dbEl.textContent || '{}')
    } catch (e) {
      return {}
    }
  }

  const db = parseDb()

  const setOptions = (select, options, placeholder) => {
    select.innerHTML = ''
    const ph = document.createElement('option')
    ph.value = ''
    ph.textContent = placeholder
    ph.disabled = true
    ph.selected = true
    select.appendChild(ph)

    options.forEach((opt) => {
      const o = document.createElement('option')
      o.value = opt
      o.textContent = opt
      select.appendChild(o)
    })
  }

  const setStatus = (mode, text) => {
    statusEl.classList.remove('is-ok', 'is-bad', 'is-info', 'is-hidden')
    if (mode === 'hide') {
      statusEl.classList.add('is-hidden')
      statusEl.textContent = ''
      return
    }
    statusEl.classList.add(mode)
    statusEl.textContent = text || ''
  }

  const setEmpty = (text, show) => {
    if (show) {
      emptyEl.classList.remove('is-hidden')
      if (typeof text === 'string') emptyEl.textContent = text
    } else {
      emptyEl.classList.add('is-hidden')
    }
  }

  const hideAll = () => {
    productEls.forEach((el) => el.classList.add('is-hidden'))
    setEmpty(t.emptySelect, true)
  }

  const applyFilter = (make, model) => {
    const keys = (db?.[make]?.[model]) || []
    const allowed = new Set(keys.map(normalize))

    let visibleCount = 0

    productEls.forEach((el) => {
      const k = normalize(el.getAttribute('data-finder-key') || '')
      const isMatch = allowed.size > 0 && k && allowed.has(k)
      if (isMatch) {
        el.classList.remove('is-hidden')
        visibleCount += 1
      } else {
        el.classList.add('is-hidden')
      }
    })

    if (visibleCount === 0) setEmpty(t.emptyNone, true)
    else setEmpty('', false)
  }

  const makes = Object.keys(db)
  setOptions(makeSelect, makes, t.makeLabel)
  setOptions(modelSelect, [], t.modelLabelFirst)
  modelSelect.disabled = true
  setStatus('hide')
  hideAll()

  const reset = () => {
    makeSelect.selectedIndex = 0
    setOptions(modelSelect, [], t.modelLabelFirst)
    modelSelect.disabled = true
    setStatus('hide')
    hideAll()
  }

  makeSelect.addEventListener('change', () => {
    const make = makeSelect.value
    const models = make ? Object.keys(db[make] || {}) : []
    modelSelect.disabled = !make
    setOptions(modelSelect, models, t.modelLabel)
    setStatus('hide')
    if (make) setEmpty(t.emptyModel, true)
    else setEmpty(t.emptySelect, true)
    productEls.forEach((el) => el.classList.add('is-hidden'))
  })

  modelSelect.addEventListener('change', () => {
    const make = makeSelect.value
    const model = modelSelect.value
    if (!make || !model) {
      setStatus('hide')
      hideAll()
      return
    }
    applyFilter(make, model)
    setStatus('is-ok', t.results(make, model))
  })

  resetBtn.addEventListener('click', reset)
})()